import color from '@helpers/color.helper'
import text from '@helpers/text.helper'

let templateFonts;
let templateFontsLanguage;

const setTemplateFonts = (value) => { return templateFonts = value }
const getTemplateFonts = () => { return templateFonts }

const setTemplateFontsLanguage = (value) => { return templateFontsLanguage = value }
const getTemplateFontsLanguage = () => { return templateFontsLanguage }

const genVarsFontTheme = (prefix, template, options = {}) => {
    const _templateFonts = getTemplateFonts();
    const _templateFontsLanguage = getTemplateFontsLanguage();
    const _ops = {
        fsMin: (options.fsMin !== undefined && options.fsMin !== null) ? options.fsMin : 8,
        fsMax: (options.fsMax !== undefined && options.fsMax !== null) ? options.fsMax : 200,
        fsrMin: (options.fsrMin !== undefined && options.fsrMin !== null) ? options.fsrMin : 8,
        fsrMax: (options.fsrMax !== undefined && options.fsrMax !== null) ? options.fsrMax : 200,
        vars: (options.vars !== undefined && options.vars !== null) ? options.vars : 'all',
    }
    
    if (!template) return;

    const style = { 
        ..._templateFonts[template], 
        ..._templateFontsLanguage[template] 
    };

    style.sizer = Math.min(Math.max(text.responsiveFontSize(style.size), _ops.fsrMin), _ops.fsrMax);

    let vars = {};
    if (_ops.vars == 'all' || _ops.vars.includes('color')) vars[`${prefix}-color`] = color.getColor(style.color);
    if (_ops.vars == 'all' || _ops.vars.includes('ff')) vars[`${prefix}-ff`] = `"${style.family}"`;
    if (_ops.vars == 'all' || _ops.vars.includes('fs')) vars[`${prefix}-fs`] = `${style.size}px`;
    if (_ops.vars == 'all' || _ops.vars.includes('fsr')) vars[`${prefix}-fsr`] = `${style.sizer}px`;
    if (_ops.vars == 'all' || _ops.vars.includes('fw')) vars[`${prefix}-fw`] = style.isBold ? 'bold' : 'normal';
    if (_ops.vars == 'all' || _ops.vars.includes('fsy')) vars[`${prefix}-fsy`] = style.isItalic ? 'italic' : 'normal';
    // if (_ops.vars == 'all' || _ops.vars.includes('fd')) vars[`${prefix}-fd`] = style.isUnderline ? 'underline' : 'unset';
    
    return vars;
}

const genVarsFont = (prefix, style, options = {}) => {
    const _templateFonts = getTemplateFonts();
    const _templateFontsLanguage = getTemplateFontsLanguage();
    const _ops = {
        fsMin: (options.fsMin !== undefined && options.fsMin !== null) ? options.fsMin : 8,
        fsMax: (options.fsMax !== undefined && options.fsMax !== null) ? options.fsMax : 200,
        fsrMin: (options.fsrMin !== undefined && options.fsrMin !== null) ? options.fsrMin : 8,
        fsrMax: (options.fsrMax !== undefined && options.fsrMax !== null) ? options.fsrMax : 200,
        vars: (options.vars !== undefined && options.vars !== null) ? options.vars : 'all',
    }
    const _style = {
        isCustom: style.fontIsCustom,
        template: style.fontStyle,
        color: style.fontColor,
        family: style.fontFamily,
        size: style.fontSize,
        isBold: style.fontIsBold,
        isItalic: style.fontIsItalic,
        isUnderline: style.fontIsUnderline,
    }
    const styleTemplate = _style.template ? { 
        ..._templateFonts[_style.template], 
        ..._templateFontsLanguage[_style.template] 
    } : {};
    const styleMerge = {
        color: _style.isCustom ? _style.color : styleTemplate.color,
        family: _style.isCustom ? _style.family : styleTemplate.family,
        size: _style.isCustom ? _style.size : styleTemplate.size,
        isBold: _style.isCustom ? _style.isBold : styleTemplate.isBold,
        isItalic: _style.isCustom ? _style.isItalic : styleTemplate.isItalic,
        isUnderline: _style.isCustom ? _style.isUnderline : false,
    }

    styleMerge.size = Math.min(Math.max(styleMerge.size, _ops.fsMin), _ops.fsMax);
    styleMerge.sizer = Math.min(Math.max(text.responsiveFontSize(styleMerge.size), _ops.fsrMin), _ops.fsrMax);
    
    let vars = {};
    if (_ops.vars == 'all' || _ops.vars.includes('color')) vars[`${prefix}-color`] = color.getColor(styleMerge.color);
    if (_ops.vars == 'all' || _ops.vars.includes('ff')) vars[`${prefix}-ff`] = `"${styleMerge.family}"`;
    if (_ops.vars == 'all' || _ops.vars.includes('fs')) vars[`${prefix}-fs`] = `${styleMerge.size}px`;
    if (_ops.vars == 'all' || _ops.vars.includes('fsr')) vars[`${prefix}-fsr`] = `${styleMerge.sizer}px`;
    if (_ops.vars == 'all' || _ops.vars.includes('fw')) vars[`${prefix}-fw`] = styleMerge.isBold ? 'bold' : 'normal';
    if (_ops.vars == 'all' || _ops.vars.includes('fsy')) vars[`${prefix}-fsy`] = styleMerge.isItalic ? 'italic' : 'normal';
    if (_ops.vars == 'all' || _ops.vars.includes('fd')) vars[`${prefix}-fd`] = styleMerge.isUnderline ? 'underline' : 'unset';
    
    return vars;
}

export {
    setTemplateFonts,
    setTemplateFontsLanguage,
    genVarsFontTheme,
    genVarsFont,
}
export default {
    setTemplateFonts,
    setTemplateFontsLanguage,
    genVarsFontTheme,
    genVarsFont,
}